export default "__VITE_ASSET__KmTd0$iZ__"